export const GET_ALL_REVIEW_REQUEST = "REVIEW.GET_ALL_REVIEW_REQUEST";
export const GET_ALL_REVIEW_SUCCESS = "REVIEW.GET_ALL_REVIEW_SUCCESS";
export const GET_ALL_REVIEW_FAILURE = "REVIEW.GET_ALL_REVIEW_FAILURE";

export const CLEAR_SEARCHTERM = "REVIEW.CLEAR_SEARCHTERM";

export const GET_SINGLE_REVIEW_REQUEST = "REVIEW.GET_SINGLE_REVIEW_REQUEST";
export const GET_SINGLE_REVIEW_SUCCESS = "REVIEW.GET_SINGLE_REVIEW_SUCCESS";
export const GET_SINGLE_REVIEW_FAILURE = "REVIEW.GET_SINGLE_REVIEW_FAILURE";

export const ADD_REVIEW_REQUEST = "REVIEW.ADD_REVIEW_REQUEST";
export const ADD_REVIEW_SUCCESS = "REVIEW.ADD_REVIEW_SUCCESS";
export const ADD_REVIEW_FAILURE = "REVIEW.ADD_REVIEW_FAILURE";

export const UPDATE_REVIEW_REQUEST = "REVIEW.UPDATE_REVIEW_REQUEST";
export const UPDATE_REVIEW_SUCCESS = "REVIEW.UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_FAILURE = "REVIEW.UPDATE_REVIEW_FAILURE";

export const DELETE_REVIEW_REQUEST = "REVIEW.DELETE_REVIEW_REQUEST";
export const DELETE_REVIEW_SUCCESS = "REVIEW.DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_FAILURE = "REVIEW.DELETE_REVIEW_FAILURE";
